import { type SvgIconProps } from "@mui/material";
import { SvgIcon as MuiSvgIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled("button")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  border: "none",
  background: "none",
  padding: 0,
  cursor: "pointer",
  color: "inherit",
}));

export const SvgIcon = styled(MuiSvgIcon)<SvgIconProps & { $small?: boolean }>(
  ({ $small, theme }) => ({
    width: "auto",
    height: $small ? "2.25rem" : "2.75rem",
    color: theme.palette.text.primary,

    "@media (max-width:576px)": {
      height: "2rem",
    },
  })
);
